import { AllowedLocales } from './formatDateTime'

const datepickerToISOFormat = (
  datepickerDate: string,
  lang: AllowedLocales = 'en-US'
) => {
  const datepickerFormatRegex =
    /^((\d{2})(\.|\/)(\d{2})(\.|\/)(\d{4}))?( \| )?((\d{2}):(\d{2}):(\d{2}))?( AM| PM)?/

  const match = datepickerDate.match(datepickerFormatRegex) ?? []

  const [
    fullMatch,
    ,
    daymonth1 = '01',
    ,
    daymonth2 = '01',
    ,
    year = '2000',
    ,
    ,
    hours = '00',
    minutes = '00',
    seconds = '00',
    meridiem = ''
  ] = match

  if (!fullMatch) {
    return null
  }

  let day = daymonth1
  let month = daymonth2

  if (lang === 'en-US') {
    day = daymonth2
    month = daymonth1
  }

  try {
    return new Date(
      `${year}-${month}-${day} ${
        meridiem === ' PM' ? parseInt(hours) + 12 : hours
      }:${minutes}:${seconds}`
    ).toISOString()
  } catch (e) {
    return null
  }
}

export default datepickerToISOFormat
